import { atomWithStorage } from "jotai/utils";

import { STORE_KEY_TOKEN } from "@utils/token.utils";

export const sessionTokenAtom = atomWithStorage<string | undefined>(
  STORE_KEY_TOKEN,
  undefined
);
